import { useQuery } from "@tanstack/react-query"
import { AlertCircle, Clock, Loader2, Instagram as InstagramIcon } from "lucide-react"
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { PostCard } from "./PostCard"
import { supabase } from "@/integrations/supabase/client"

export const PostsList = () => {
  const { data: posts, isLoading, error } = useQuery({
    queryKey: ["instagram-posts"],
    queryFn: async () => {
      console.log("Buscando posts...")
      
      const { data: { user }, error: userError } = await supabase.auth.getUser()
      if (userError) {
        console.error("Erro ao obter usuário:", userError)
        throw userError
      }
      
      if (!user) {
        console.error("Usuário não encontrado")
        throw new Error("Usuário não encontrado")
      }

      const { data, error: postsError } = await supabase
        .from("instagram_posts")
        .select("*")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false })

      if (postsError) {
        console.error("Erro ao buscar posts:", postsError)
        throw postsError
      }
      
      return data
    },
  })

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <Card className="p-6 flex items-center justify-center text-red-500">
          <AlertCircle className="w-6 h-6 mr-2" />
          <span>Erro ao carregar os posts: {error.message}</span>
        </Card>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold flex items-center gap-2">
        <Clock className="w-5 h-5 text-primary" />
        Posts Recentes
      </h2>
      
      {isLoading ? (
        <div className="flex items-center justify-center p-8">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : posts && posts.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {posts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <Card className="p-6 text-center">
          <CardHeader>
            <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
              <InstagramIcon className="w-6 h-6 text-primary" />
            </div>
            <CardTitle className="text-xl">Nenhum post encontrado</CardTitle>
            <CardDescription>
              Crie sua primeira postagem para o Instagram!
            </CardDescription>
          </CardHeader>
        </Card>
      )}
    </div>
  )
}